"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toChunks = void 0;
const toChunks = (size, xs) => xs.reduce((segments, _, index) => index % size === 0 ? [...segments, xs.slice(index, index + size)] : segments, []);
exports.toChunks = toChunks;
